import * as React from 'react'

import { cn } from '@/lib/utils'

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        `
          flex py-1.5 w-full rounded-md border border-[#D4D8E3] bg- px-4
          text-base  bg-background ring-offset-background
          outline-none transition duration-200

          disabled:cursor-not-allowed disabled:opacity-50

          file:border-0 file:bg-transparent file:text-sm file:font-medium
          placeholder:text-muted-foreground
        `,
        className
      )}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = 'Input'

export { Input }
